import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { OrderListPage } from '@/features/orders'

export const Route = createFileRoute('/_authenticated/orders/')({
  component: () => (
    <RequirePermission permission='orders.read'>
      <OrderListPage />
    </RequirePermission>
  ),
})
